var randIndex;
var posicaoFlutuante;
window.onload = function () {
  window.setTimeout(checkGeoLocation, 100);

  //Carregando as vitrines da home por ajax
  $(".vitrine-container").each(function () {
    var url = $(this).data("vitrineurl");

    if (!homeSemCidade && params.cidade_id)
      url +=
        (url.indexOf("?") > -1 ? "&" : "?") +
        "cidade_id=" +
        params.cidade_id +
        "&tipo_id=" +
        ("tipo_id" in params ? params.tipo_id : 1); //Cidade da vitrine

    $.ajax({
      url: url,
      context: this,
    }).done(function (data) {
      $(this).html(data);
      onloadHomeVitrine();
    });
  });

  initSwiper(function () {
    var swiperConcessionarias = new Swiper(".swiper-concessionarias", {
      loop: true,
      spaceBetween: 25, // Espa?o entre os slides
      autoplay: {
        delay: 5000, // 5 segundos
        disableOnInteraction: false, // Continua ap?s intera??o
      },
      navigation: false, // Navega??o por setas desabilitada
      pagination: {
        el: ".swiper-pagination",
        clickable: true, // Se quiser habilitar pagina??o
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        1000: {
          slidesPerView: 3,
        },
        1000: {
          slidesPerView: 4,
        },
        1440: {
          slidesPerView: 5,
        },
        1920: {
          slidesPerView: 7,
        },
      },
    });
  });
};

function onloadHomeVitrine(r, i, j) {

  initSwiper(function () {

    $(".swiper-homeveiculo").shuffleSlides();

    var swiperVeic = new Swiper(".swiper-homeveiculo", {
      loop: true,
      lazy: true, // Lazy loading para as imagens
      autoplay: {
        delay: 70000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          centeredSlides: true,
        },
        900: {
          slidesPerView: 3,
        },
        1000: {
          slidesPerView: 4,
        },
        1360: {
          slidesPerView: 5,
        },
        1920: {
          slidesPerView: 7,
        },
        2200: {
          slidesPerView: 8,
        },
      },
    });

    swiperVeic.on("init", function () {
      if ($(".swiper-homeveiculo").length === 0) {
        $(".swiper-homeveiculo").parent().parent().hide();
      }
    });

    // Inicializar o Swiper manualmente ap?s adicionar o evento

    listDOMReady();
  });
}

defer(function () {
  checkHomeRedir(); //Redirecionando a home da cidade se ja tiver no cookie

  if (window.location.hash.indexOf("/veiculos") > -1) return;

  $('.swiper-logorevendedores-peq').shuffleSlides();

  initSwiper(function () {

    var swiperLogoRevendedores = new Swiper(".swiper-logorevendedores-peq", {
      loop: true,
      navigation: false,
      autoplay: {
        delay: 5000, // 8 segundos
        disableOnInteraction: false,
      },
      lazy: true,
      breakpoints: {
        0: {
          slidesPerView: 2,
        },
        1000: {
          slidesPerView: 4,
        },
        1360: {
          slidesPerView: 7,
        },
        1920: {
          slidesPerView: 8,
        },
      },
      on: {
        init: function () {
          var slides = this.slides;
          for (var i = 0; i < slides.length; i++) {
            var randomIndex = Math.floor(Math.random() * slides.length);
            slides[i].parentNode.insertBefore(slides[randomIndex], slides[i]);
          }
        },
      },
    });
  });

  if (window.innerWidth < 1024) return;

  if ($(".flutuante").length && !$("#TB_overlay").length)
    $("body").prepend("<div id='TB_overlay'></div>");

  $("#TB_overlay, div.flutuante #fechar, div.flutuante a").click(function () {
    $("div.flutuante").remove();
    $("#TB_overlay").remove();
  });

  posicaoFlutuante = function () {
    if (window.location.href.indexOf("/veiculos") > -1) return;

    var randIndex = Math.floor(
      Math.random() * $("div.flutuante .banners .banner-item").length
    );
    console.log("randIndex", randIndex);
    $("div.flutuante .banners .banner-item").hide();
    var bannerEl = $(
      "div.flutuante .banners .banner-item:eq(" + randIndex + ")"
    );

    bannerEl.show();

    if (bannerEl.hasClass("banner-html")) {
      bannerEl.width(bannerEl.data("width")).height(bannerEl.data("height"));
      $("div.flutuante").center();
    } else {
      bannerEl.find("img").on("load", function () {
        $("div.flutuante").center();
      });
    }

    var w = $(window);
    var flu = $("div.flutuante");

    flu.prependTo("body");

    flu.css("position", "fixed").css("display", "block");
  };

  posicaoFlutuante();
});
